export enum CarrierType {
  None = 0,
  DHL = 1,
  FedEx = 2,
  TKCargo = 3,
  Other = 4,
  JetpakSTD = 5,
}

export const GetCarrierType = [
  // { Description: "None", Value: CarrierType.None },
  { Description: "DHL", Value: CarrierType.DHL },
  { Description: "FedEx", Value: CarrierType.FedEx },
  { Description: "Turkish Cargo", Value: CarrierType.TKCargo },
  { Description: "Other", Value: CarrierType.Other },
  { Description: "JETPAK STD", Value: CarrierType.JetpakSTD },
];
